import { SVGProps } from "types";

const IllustrationLocation = (props: SVGProps) => {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2042_6613)">
        <path
          d="M70.1644 26.0841C66.0915 24.4967 62.6505 21.6 60.5461 17.7686C57.0072 11.3255 50.1597 6.95801 42.2893 6.95801C34.1201 6.95801 27.0533 11.6634 23.6449 18.5113C21.5573 22.7052 18.0049 25.9982 13.6606 27.7514C7.24128 30.3423 1.8523 36.2634 0.142148 45.5202C-0.0455393 46.536 -0.0482893 47.5803 0.139398 48.5961C2.79452 62.9602 14.3017 69.2959 24.7749 67.6158C30.6403 66.6749 36.5779 68.6314 40.9255 72.6796C49.7657 80.911 63.9368 83.4917 77.6935 74.6682C79.3052 73.6345 81.4674 71.4655 82.5002 69.8531C94.3537 51.3475 85.5731 32.0899 70.1644 26.0841Z"
          fill="url(#paint0_linear_2042_6613)"
        />
        <path
          opacity="0.1"
          d="M75.7971 15.2472H55.5618C53.9889 10.362 49.4085 6.82617 44.0002 6.82617C38.592 6.82617 34.0116 10.362 32.4387 15.2472H12.2034C10.7802 15.2472 9.62524 16.4022 9.62524 17.8253V61.5245C9.62524 62.9477 10.7802 64.1027 12.2034 64.1027H75.7969C77.2201 64.1027 78.3751 62.9477 78.3751 61.5245V17.8253C78.3752 16.4022 77.2202 15.2472 75.7971 15.2472Z"
          fill="#2626BC"
        />
        <path
          d="M53.7472 80.2081H34.2529L38.1514 64.7559H49.8487L53.7472 80.2081Z"
          fill="#9FB0FE"
        />
        <path
          d="M51.2066 70.1359H36.7937L38.1515 64.7559H49.8488L51.2066 70.1359Z"
          fill="#8399FE"
        />
        <path
          d="M78.3752 21.4355V65.1348C78.3752 66.5579 77.2202 67.7129 75.7971 67.7129H12.2034C10.7802 67.7129 9.62524 66.5579 9.62524 65.1348V21.4355C9.62524 20.0124 10.7802 18.8574 12.2034 18.8574H75.7969C77.2202 18.8574 78.3752 20.0124 78.3752 21.4355Z"
          fill="white"
        />
        <path
          d="M9.62524 50.5928V65.1348C9.62524 66.5579 10.7802 67.7129 12.2034 67.7129H75.7969C77.2201 67.7129 78.3751 66.5579 78.3751 65.1348V50.5928H9.62524Z"
          fill="#FFC4DF"
        />
        <path
          d="M18.1637 47.1566H9.62524V35.0088H18.1637C18.4484 35.0088 18.6793 35.2396 18.6793 35.5244V46.6409C18.6793 46.9257 18.4484 47.1566 18.1637 47.1566Z"
          fill="#97FFD2"
        />
        <path
          d="M78.3751 47.1566H69.8367C69.5519 47.1566 69.321 46.9257 69.321 46.6409V35.5244C69.321 35.2396 69.5519 35.0088 69.8367 35.0088H78.3751V47.1566Z"
          fill="#97FFD2"
        />
        <path
          d="M64.5214 47.1566H23.479C23.1942 47.1566 22.9634 46.9257 22.9634 46.6409V35.5244C22.9634 35.2396 23.1942 35.0088 23.479 35.0088H64.5214C64.8062 35.0088 65.037 35.2396 65.037 35.5244V46.6409C65.037 46.9257 64.8062 47.1566 64.5214 47.1566Z"
          fill="#97FFD2"
        />
        <path
          d="M44.0001 44.462C47.98 44.462 51.2064 43.7445 51.2064 42.8594C51.2064 41.9743 47.98 41.2568 44.0001 41.2568C40.0201 41.2568 36.7937 41.9743 36.7937 42.8594C36.7937 43.7445 40.0201 44.462 44.0001 44.462Z"
          fill="#02FFB3"
        />
        <path
          d="M78.3752 27.1368V21.4355C78.3752 20.0117 77.2209 18.8574 75.7971 18.8574H12.2034C10.7796 18.8574 9.62524 20.0117 9.62524 21.4355V27.1368H78.3752Z"
          fill="#6583FE"
        />
        <path
          d="M9.62524 59.0518V65.1344C9.62524 66.5582 10.7796 67.7125 12.2034 67.7125H75.7969C77.2207 67.7125 78.3751 66.5582 78.3751 65.1344V59.0518H9.62524Z"
          fill="#B7C5FF"
        />
        <path
          d="M56.146 22.5814C56.146 27.8989 48.5139 38.143 45.3495 42.1616C44.6615 43.0354 43.3388 43.0354 42.6507 42.1616C39.4865 38.143 31.8542 27.8989 31.8542 22.5814C31.8542 15.8735 37.2922 10.4355 44.0001 10.4355C50.7081 10.4355 56.146 15.8735 56.146 22.5814Z"
          fill="#FF7EB8"
        />
        <path
          d="M49.7306 23.2588C50.4915 20.0844 48.535 16.8942 45.3606 16.1332C42.1862 15.3723 38.9959 17.3288 38.235 20.5032C37.474 23.6776 39.4306 26.8678 42.605 27.6288C45.7794 28.3897 48.9696 26.4332 49.7306 23.2588Z"
          fill="white"
        />
        <path
          d="M16.1707 22.125C15.6959 22.125 15.3113 22.5097 15.3113 22.9844V23.0093C15.3113 23.484 15.6959 23.8687 16.1707 23.8687C16.6454 23.8687 17.03 23.484 17.03 23.0093V22.9844C17.03 22.5098 16.6454 22.125 16.1707 22.125Z"
          fill="#2626BC"
        />
        <path
          d="M19.4922 22.125C19.0175 22.125 18.6328 22.5097 18.6328 22.9844V23.0093C18.6328 23.484 19.0175 23.8687 19.4922 23.8687C19.9669 23.8687 20.3516 23.484 20.3516 23.0093V22.9844C20.3516 22.5098 19.9669 22.125 19.4922 22.125Z"
          fill="#2626BC"
        />
        <path
          d="M22.8135 22.125C22.3388 22.125 21.9541 22.5097 21.9541 22.9844V23.0093C21.9541 23.484 22.3388 23.8687 22.8135 23.8687C23.2882 23.8687 23.6729 23.484 23.6729 23.0093V22.9844C23.6729 22.5098 23.2882 22.125 22.8135 22.125Z"
          fill="#2626BC"
        />
        <path
          d="M75.7971 17.9977H56.169C54.3112 13.0821 49.5583 9.57617 44.0002 9.57617C38.4421 9.57617 33.6895 13.0821 31.8315 17.9977H12.2034C10.3079 17.9977 8.76587 19.5398 8.76587 21.4352V65.1339C8.76587 67.0293 10.3079 68.5714 12.2034 68.5714H36.3028L33.5839 79.3481H30.9493C30.4745 79.3481 30.0899 79.7328 30.0899 80.2075C30.0899 80.6822 30.4745 81.0669 30.9493 81.0669H57.0514C57.5261 81.0669 57.9108 80.6822 57.9108 80.2075C57.9108 79.7328 57.5261 79.3481 57.0514 79.3481H54.4166L51.6977 68.5714H75.7971C77.6926 68.5714 79.2346 67.0293 79.2346 65.1339V59.0514C79.2346 58.5767 78.85 58.1921 78.3752 58.1921C78.3589 58.1921 78.3438 58.196 78.3278 58.1969C78.3118 58.196 78.2965 58.1921 78.2804 58.1921H10.4846V27.996H32.459C33.228 29.7175 34.2972 31.6678 35.6655 33.8394C35.9185 34.2411 36.4493 34.3616 36.8508 34.1084C37.2524 33.8554 37.3727 33.3247 37.1197 32.9232C34.2372 28.3482 32.7137 24.772 32.7137 22.5813C32.7137 16.3578 37.7768 11.2947 44.0002 11.2947C50.2237 11.2947 55.2868 16.3578 55.2868 22.5813C55.2868 27.7506 47.1639 38.4682 44.6747 41.6297C44.5107 41.838 44.2648 41.9572 44.0002 41.9572C43.7357 41.9572 43.4898 41.838 43.326 41.6298C42.4616 40.5319 41.1344 38.8037 39.7204 36.8036C39.4462 36.416 38.91 36.3244 38.5224 36.598C38.1348 36.8722 38.0429 37.4084 38.3169 37.796C39.7522 39.826 41.0986 41.5796 41.9756 42.6932C42.4675 43.318 43.2053 43.6762 44.0001 43.6762C44.7948 43.6762 45.5327 43.318 46.0248 42.693C48.9556 38.9709 53.305 33.0375 55.5489 27.9958H77.5159V54.3178C77.5159 54.7925 77.9005 55.1772 78.3752 55.1772C78.85 55.1772 79.2346 54.7925 79.2346 54.3178V21.4352C79.2346 19.5396 77.6926 17.9977 75.7971 17.9977ZM52.644 79.3481H35.3563L38.075 68.5714H49.9249L52.644 79.3481ZM77.5159 59.9108V65.1339C77.5159 66.0816 76.7448 66.8527 75.7971 66.8527H12.2034C11.2557 66.8527 10.4846 66.0816 10.4846 65.1339V59.9108H77.5159ZM10.4846 26.2773V21.4352C10.4846 20.4875 11.2557 19.7165 12.2034 19.7165H31.3169C31.1086 20.6389 30.995 21.5969 30.995 22.5814C30.995 23.6127 31.2562 24.8492 31.7667 26.2773H10.4846ZM56.2415 26.2773C56.7241 24.9217 57.0055 23.6661 57.0055 22.5814C57.0055 21.5969 56.8919 20.6389 56.6836 19.7165H75.7971C76.7448 19.7165 77.5159 20.4875 77.5159 21.4352V26.2773H56.2415Z"
          fill="#2626BC"
        />
        <path
          d="M44.0003 28.6384C47.735 28.6384 50.773 25.6002 50.773 21.8657C50.773 18.1312 47.735 15.0928 44.0003 15.0928C40.2656 15.0928 37.2275 18.131 37.2275 21.8655C37.2275 25.6 40.2656 28.6384 44.0003 28.6384ZM44.0003 16.8115C46.7871 16.8115 49.0543 19.0787 49.0543 21.8655C49.0543 24.6523 46.7871 26.9197 44.0003 26.9197C41.2135 26.9197 38.9463 24.6525 38.9463 21.8657C38.9463 19.0789 41.2135 16.8115 44.0003 16.8115Z"
          fill="#2626BC"
        />
        <path
          d="M17.9703 55.1486C18.5016 55.1486 18.9323 54.7179 18.9323 54.1866C18.9323 53.6553 18.5016 53.2246 17.9703 53.2246C17.439 53.2246 17.0083 53.6553 17.0083 54.1866C17.0083 54.7179 17.439 55.1486 17.9703 55.1486Z"
          fill="white"
        />
        <path
          d="M20.8802 55.1486C21.4115 55.1486 21.8422 54.7179 21.8422 54.1866C21.8422 53.6553 21.4115 53.2246 20.8802 53.2246C20.3489 53.2246 19.9182 53.6553 19.9182 54.1866C19.9182 54.7179 20.3489 55.1486 20.8802 55.1486Z"
          fill="white"
        />
        <path
          d="M23.7906 55.1486C24.3219 55.1486 24.7526 54.7179 24.7526 54.1866C24.7526 53.6553 24.3219 53.2246 23.7906 53.2246C23.2593 53.2246 22.8286 53.6553 22.8286 54.1866C22.8286 54.7179 23.2593 55.1486 23.7906 55.1486Z"
          fill="white"
        />
        <path
          d="M35.6422 53.3252H32.7657C32.3161 53.3252 31.9146 53.6538 31.872 54.1014C31.823 54.6148 32.2253 55.0469 32.7288 55.0469H35.6422C36.1176 55.0469 36.503 54.6615 36.503 54.186C36.503 53.7107 36.1176 53.3252 35.6422 53.3252Z"
          fill="white"
        />
        <path
          d="M70.0942 53.3252H39.828C39.3526 53.3252 38.9673 53.7105 38.9673 54.186C38.9673 54.6614 39.3526 55.0469 39.828 55.0469H70.1311C70.6346 55.0469 71.0369 54.6148 70.9879 54.1014C70.9453 53.654 70.5438 53.3252 70.0942 53.3252Z"
          fill="#FF7EB8"
        />
        <path
          d="M62.055 12.3483C61.5803 12.3483 61.1956 11.9636 61.1956 11.4889C61.1956 10.9188 60.7319 10.4549 60.1616 10.4549C59.6869 10.4549 59.3022 10.0702 59.3022 9.59552C59.3022 9.1208 59.6869 8.73615 60.1616 8.73615C60.7317 8.73615 61.1956 8.27243 61.1956 7.70215C61.1956 7.22743 61.5803 6.84277 62.055 6.84277C62.5297 6.84277 62.9144 7.22743 62.9144 7.70215C62.9144 8.27226 63.3781 8.73615 63.9484 8.73615C64.4231 8.73615 64.8077 9.1208 64.8077 9.59552C64.8077 10.0702 64.4231 10.4549 63.9484 10.4549C63.3783 10.4549 62.9144 10.9186 62.9144 11.4889C62.9144 11.9634 62.5297 12.3483 62.055 12.3483Z"
          fill="#97FFD2"
        />
        <path
          d="M21.8423 77.1285C21.3676 77.1285 20.983 76.7439 20.983 76.2692C20.983 75.6991 20.5193 75.2352 19.949 75.2352C19.4743 75.2352 19.0896 74.8505 19.0896 74.3758C19.0896 73.9011 19.4743 73.5164 19.949 73.5164C20.5191 73.5164 20.983 73.0527 20.983 72.4824C20.983 72.0077 21.3676 71.623 21.8423 71.623C22.3171 71.623 22.7017 72.0077 22.7017 72.4824C22.7017 73.0525 23.1654 73.5164 23.7357 73.5164C24.2104 73.5164 24.5951 73.9011 24.5951 74.3758C24.5951 74.8505 24.2104 75.2352 23.7357 75.2352C23.1656 75.2352 22.7017 75.6989 22.7017 76.2692C22.7017 76.7439 22.3171 77.1285 21.8423 77.1285Z"
          fill="#6583FE"
        />
        <path
          d="M62.0548 77.1248C61.835 77.1248 61.6148 77.041 61.4473 76.873L59.5577 74.9835C59.222 74.648 59.222 74.1038 59.5577 73.7683L61.4473 71.8787C61.7826 71.543 62.3271 71.543 62.6624 71.8787L64.552 73.7683C64.8877 74.1038 64.8877 74.648 64.552 74.9835L62.6624 76.873C62.4947 77.0408 62.2747 77.1248 62.0548 77.1248ZM61.3806 74.3757L62.0548 75.05L62.7291 74.3757L62.0548 73.7014L61.3806 74.3757Z"
          fill="#FF7EB8"
        />
        <path
          d="M70.9921 81.1737C70.7723 81.1737 70.5521 81.0898 70.3845 80.9219L68.4949 79.0323C68.1592 78.6968 68.1592 78.1526 68.4949 77.8171L70.3845 75.9275C70.7199 75.5919 71.2644 75.5919 71.5997 75.9275L73.4893 77.8171C73.825 78.1526 73.825 78.6968 73.4893 79.0323L71.5997 80.9219C71.4321 81.0898 71.2119 81.1737 70.9921 81.1737ZM70.3178 78.4247L70.9921 79.099L71.6664 78.4247L70.9921 77.7504L70.3178 78.4247Z"
          fill="#FF7EB8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2042_6613"
          x1="8.32443"
          y1="23.0361"
          x2="86.4657"
          y2="70.7632"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0485" stopColor="#D2DEFF" />
          <stop offset="0.9993" stopColor="#DCFDEE" />
        </linearGradient>
        <clipPath id="clip0_2042_6613">
          <rect width="88" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationLocation;
